export default __webpack_public_path__ + "media/transfer_window/Instruction_add_to_home_Android-c6c7b622.png";